// extracted by mini-css-extract-plugin
export default {"input_group":"SettingsSelect_input_group__Qt9VN"};